export * from '@bmi/directives/scrollbar/scrollbar.directive';
export * from '@bmi/directives/scrollbar/scrollbar.module';
